import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { formSubmissionRefs } from "../subjects/formSubmission/refs";

/**
 * The driver arrived at a drop or swap location.
 */
export const dropSwapArrivalV1 = tmsEventKind(
  { category: "checkIn", kind: "dropSwapArrival", version: 1 },
  {
    refs: formSubmissionRefs,
    facts: {
      /** Free text as the driver typed it; no place vocabulary behind it. */
      dropLocation: z.string().nullable(),
    },
  },
);

export const DropSwapArrivalV1Schema = dropSwapArrivalV1.schema;
export const DropSwapArrivalV1FactsSchema = dropSwapArrivalV1.facts;

export type DropSwapArrivalV1 = z.infer<typeof DropSwapArrivalV1Schema>;
export type DropSwapArrivalV1Facts = z.infer<typeof DropSwapArrivalV1FactsSchema>;

/** Every version of `dropSwapArrival`, keyed by version. What `catalog.ts` places under `checkIn`. */
export const dropSwapArrival = { 1: dropSwapArrivalV1 } as const;
